import * as firebase from 'firebase/app';
import Information from '../models/Information.js';
require('firebase/firestore');


const state = {
  informations: []
};

const getters = {
  getInformations: state => state.informations
};

const actions = {
  getAllInformations({
    commit
  }) {
    firebase.firestore().collection("informations").onSnapshot(snapshot => {
      commit("setLoading", true);

      let informations = [];
      snapshot.forEach(doc => {
        let i = new Information(doc.id, doc.data().category, doc.data().info);
        informations.push(i);
      });
      commit("setInformations", informations);
      commit("setLoading", false);
    }, error => {
      commit("setLoading", false);
      console.error(error);
    });
  }
};

const mutations = {
  setInformations(state, informations) {
    state.informations = informations
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};